<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'NAVIGATION.TABS.ANALYTICS' | translate }}
    </glxy-page-title>
    <glxy-page-actions>
      <a class="toolbar-help-button" mat-icon-button routerLink="{{ settingsUrl }}">
        <mat-icon>settings</mat-icon>
      </a>
      <a class="toolbar-help-button" mat-icon-button href="https://websitepro.zendesk.com/hc/en-us">
        <mat-icon>help_outline</mat-icon>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    @if (isGaEnabled) {
      <div class="center">
        @if (site$ | async; as site) {
          @if ((ga4ViewNotFound$ | async) === false || null) {
            @if (gaViewLoading$ | async) {
              <mat-spinner [diameter]="40" />
            } @else if (ga4ViewError$ | async) {
              <glxy-empty-state>
                <mat-icon glxyEmptyStateHero>error_outline</mat-icon>
                <span glxyEmptyStateTitle>Unable to Load Results</span>
              </glxy-empty-state>
            } @else if (ga4View$ | async; as ga4View) {
              @if (gaViewCollectionRunning$ | async) {
                <div class="collection-running">
                  <p>
                    <mat-icon>info</mat-icon>
                    {{ 'ANALYTICS.ANALYTICS_PANEL.DATA_COLLECTION_RUNNING' | translate }}
                  </p>
                </div>
              }
              @if (ga4View.isBroken) {
                <span>
                  {{ 'ANALYTICS.ANALYTICS_PANEL.BROKEN_GA_VIEW_CTA' | translate }}
                </span>
                <a href="{{ connectGALink$ | async }}" target="_blank">
                  <button color="accent" mat-raised-button>
                    {{ 'ANALYTICS.ANALYTICS_PANEL.RECONNECT_GA_VIEW_CTA' | translate }}
                  </button>
                </a>
              }
              <div class="title-bar">
                <div class="connected-view-name">
                  {{ ga4View.propertyName }}
                </div>
                <div class="analytics-header">
                  <div #dateContainer>
                    @if (selectedTimeRange$ | async; as dateKey) {
                      <button
                        #dateSelector
                        class="date-select"
                        mat-stroked-button
                        (click)="openDateSelector(dateContainer)"
                      >
                        <span class="icon">
                          <mat-icon>calendar_today</mat-icon>
                        </span>
                        @if (dateKey.key !== 'custom') {
                          <span class="message">
                            {{ dateKey.i18nName | translate }}
                          </span>
                        }
                        @if (dateKey.key === 'custom') {
                          @if (dateSelectorDate$ | async; as dateRange) {
                            <span class="message">
                              {{ dateRange[0] | date: 'mediumDate' }}
                              - {{ dateRange[1] | date: 'mediumDate' }}
                            </span>
                          }
                        }
                      </button>
                    }
                  </div>
                </div>
              </div>
              <mat-card-content>
                @if ((ga4ViewNotFound$ | async) === false || null) {
                  <div>
                    <app-ga4-metrics
                      [partnerId]="site.partnerId"
                      [businessId]="site.accountId"
                      [siteId]="site.siteId"
                      [defaultTracking]="false"
                    ></app-ga4-metrics>
                  </div>
                }
              </mat-card-content>
            }
          }
          @if ((ga4ViewNotFound$ | async) === true || null) {
            @if ((connectGALinkLoading$ | async) === false) {
              @if ((connectGALinkError$ | async) === false) {
                <div class="title-bar">
                  <a href="{{ connectGALink$ | async }}" class="connect-google-analytics-button" target="_blank">
                    <button color="accent" mat-raised-button>
                      {{ 'ANALYTICS.ANALYTICS_PANEL.CONNECT_GA_VIEW_CTA' | translate }}
                    </button>
                  </a>
                  <span class="or-connector">or</span>
                  <a href="{{ createGoogleAnalyticsAccount }}" class="connect-google-analytics-button" target="_blank">
                    <button mat-raised-button color="accent">
                      {{ 'ANALYTICS.ANALYTICS_PANEL.CREATE_GA_VIEW_CTA' | translate }}
                    </button>
                  </a>
                  <div class="analytics-header">
                    <div #dateContainer>
                      @if (selectedTimeRange$ | async; as dateKey) {
                        <button
                          #dateSelector
                          class="date-select"
                          mat-stroked-button
                          (click)="openDateSelector(dateContainer)"
                        >
                          <span class="icon">
                            <mat-icon>calendar_today</mat-icon>
                          </span>
                          @if (dateKey.key !== 'custom') {
                            <span class="message">
                              {{ dateKey.i18nName | translate }}
                            </span>
                          }
                          @if (dateKey.key === 'custom') {
                            @if (dateSelectorDate$ | async; as dateRange) {
                              <span class="message">
                                {{ dateRange[0] | date: 'mediumDate' }}
                                - {{ dateRange[1] | date: 'mediumDate' }}
                              </span>
                            }
                          }
                        </button>
                      }
                    </div>
                  </div>
                </div>
              }
            } @else {
              <mat-spinner class="info-spinner" color="accent" [diameter]="60" [strokeWidth]="8"></mat-spinner>
            }
            <!-- @if ((this.google_analyticsGA4DefaultGraph$ | async) === true) {
            <app-ga4-metrics
              [partnerId]="site.partnerId"
              [businessId]="site.accountId"
              [siteId]="site.siteId"
              [defaultTracking]="true"
            ></app-ga4-metrics>
          } @else {
            <app-ga-metrics
              [partnerId]="site.partnerId"
              [businessId]="site.accountId"
              [siteId]="site.siteId"
              [defaultTracking]="true"
            ></app-ga-metrics>
          } -->
            <app-ga4-metrics
              [partnerId]="site.partnerId"
              [businessId]="site.accountId"
              [siteId]="site.siteId"
              [defaultTracking]="true"
            ></app-ga4-metrics>
          }
        }
      </div>
    }

    @if (!isGaEnabled) {
      <div class="center">
        <div class="text-center">
          @if (gaImgUrl) {
            <img src="{{ gaImgUrl }}" alt="logo" class="ga-logo" />
          }
          <div>
            <b>{{ 'ANALYTICS.ANALYTICS_PANEL.GA_DISABLED' | translate }}</b>
          </div>
          <div class="desc-text">{{ 'ANALYTICS.ANALYTICS_PANEL.GA_DISABLED_DESC' | translate }}</div>
          <div class="mt-5">
            <a mat-stroked-button routerLink="{{ settingsUrl }}">
              {{ 'ANALYTICS.ANALYTICS_PANEL.GA_DISABLED_EDIT' | translate }}
            </a>
          </div>
        </div>
      </div>
    }
  </glxy-page-wrapper>
</glxy-page>
